import { render, staticRenderFns } from "./AccountPaymentVoucher.vue?vue&type=template&id=2784b578&"
import script from "./AccountPaymentVoucher.vue?vue&type=script&lang=js&"
export * from "./AccountPaymentVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports